var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "multi-avatar-wrapper" }, [
      _vm.first && _vm.idList.length > 0
        ? _c(
            "div",
            { staticClass: "agent-avatar first" },
            [
              _c("Avatar", {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: { content: _vm.first.name, placement: "bottom" },
                    expression: "{ content: first.name, placement: 'bottom' }",
                  },
                ],
                attrs: {
                  size: 50,
                  src: _vm.first.gravatar,
                  username: _vm.first.name,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.second && _vm.idList.length > 1
        ? _c(
            "div",
            { staticClass: "agent-avatar second" },
            [
              _c("Avatar", {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: { content: _vm.second.name, placement: "bottom" },
                    expression: "{ content: second.name, placement: 'bottom' }",
                  },
                ],
                attrs: {
                  size: 50,
                  src: _vm.second.gravatar,
                  username: _vm.second.name,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.third && _vm.idList.length > 2
        ? _c(
            "div",
            { staticClass: "agent-avatar third" },
            [
              _c("Avatar", {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: { content: _vm.third.name, placement: "bottom" },
                    expression: "{ content: third.name, placement: 'bottom' }",
                  },
                ],
                attrs: {
                  size: 50,
                  src: _vm.third.gravatar,
                  username: _vm.third.name,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.idList.length > 3
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: { content: _vm.getExtraUsers(), placement: "bottom" },
                  expression:
                    "{ content: getExtraUsers(), placement: 'bottom' }",
                },
              ],
              staticClass: "number",
            },
            [
              _vm._v(
                "\n            +" + _vm._s(_vm.idList.length - 3) + "\n        "
              ),
            ]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }